'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.shape({
  x: _propTypes2.default.object,
  y: _propTypes2.default.object
})]);


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Helpers/fixedToShape.js
// module id = 19
// module chunks = 79611799117203 213534597649335